// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { Checkbox } from '@checkout/react-components';

// Internal modules
import { buildMPPUrl, getContent } from '@/lib';
import { checkboxLabelStyleOverrides } from '@/styles';
import { TermsLink } from '../../../Common';

const getTermsLinks = () => ({
  moreInformationLink: (
    <TermsLink
      href={buildMPPUrl({ mppPath: 'paypal-and-your-data' })}
      text={getContent('compliance.moreInformation')}
    />
  ),
});

const MarketingOptIn = ({ changeHandler }) => {
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const marketingOptIn = useStoreState(({ form }) => form.marketingOptIn);

  return (
    <Checkbox
      changeHandler={changeHandler}
      checked={marketingOptIn.value}
      disabled={isFormSubmitting}
      id="marketingOptIn"
      label={getContent('terms.marketingOptIn', getTermsLinks())}
      labelStyleOverrides={checkboxLabelStyleOverrides}
      name="marketingOptIn"
    />
  );
};

MarketingOptIn.propTypes = {
  changeHandler: func,
};

export { MarketingOptIn };
